import { CommonModule } from '@angular/common';
import { Component, Inject, Input, OnInit } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ClientCoreModule, ClientEnvironment, ENVIRONMENT } from '@thehubz/client/core';
import { Asset, CreateAssetDto } from '@thehubz/client/data-access-api';
import { CustomClients } from '@thehubz/shared/branding';
import { AnyType, Metadata } from '@thehubz/shared/model';
import { AssetTypeTranslationPipe } from '../../../../pipes/asset-type-translation/asset-type-translation.pipe';
import { AssetNotificationsComponent } from '../../asset-notifications/asset-notifications.component';

@Component({
  selector: 'thehubz-asset-file-info',
  templateUrl: './asset-file-info.component.html',
  styleUrls: ['./asset-file-info.component.scss'],
  standalone: true,
  imports: [CommonModule, ClientCoreModule, AssetNotificationsComponent, AssetTypeTranslationPipe, MatTooltipModule],
})
export class AssetFileInfoComponent implements OnInit {
  @Input() assetInfo!: Asset;

  AssetTypes = CreateAssetDto.AssetTypeEnum;
  CustomClients = CustomClients;

  isCustomClients = false;

  metadata?: AnyType;
  customFields: AnyType = {};
  durationString?: string;
  heightString?: string;
  widthString?: string;
  brandingKey!: CustomClients;

  constructor(@Inject(ENVIRONMENT) env: ClientEnvironment) {
    this.brandingKey = env.brandingKey ?? CustomClients.Standard;
  }

  ngOnInit(): void {
    const version = this.assetInfo.currentVersion;
    this.customFields = this.assetInfo.customFields;
    const defaultRatio = version?.aspectRatios?.find((ar) => ar.aspectRatio === version.defaultAspectRatio);
    const mainFile = defaultRatio?.formats?.find((f) => f.fileNameRef === defaultRatio.defaultFileFormat);
    this.metadata = mainFile?.metadata || {};

    this.heightString = Metadata(this.metadata).getHeight();
    this.heightString = this.heightString ? this.heightString + ' px' : this.heightString;

    this.widthString = Metadata(this.metadata).getWidth();
    this.widthString = this.widthString ? this.widthString + ' px' : this.widthString;

    this.durationString = Metadata(this.metadata).getDuration();

    this.isCustomClients = [CustomClients.VKB, CustomClients.SEAT].includes(this.brandingKey);
  }
}
